import { useSelector } from 'react-redux'
import type { RootState } from 'state/store.types'
import type { LocationState } from 'state/locationReducer'

export const useLocationHistory = (): LocationState =>
	useSelector((state: RootState) => state.location as unknown as LocationState)
